import { uniq } from 'lodash-es';

export default {
  methods: {
    fixCommasAndSpaces(minutes, hours) {
      let minutesForReturn = minutes.replaceAll(' ', '');
      let hoursForReturn = hours.replaceAll(' ', '');
      if (minutes[minutes.length - 1] === ',') {
        minutesForReturn = minutes.slice(0, -1);
      }
      if (minutes[0] === ',') {
        minutesForReturn = minutes.slice(1, minutes.length);
      }
      if (hours[hours.length - 1] === ',') {
        hoursForReturn = hours.slice(0, -1);
      }
      if (hours[0] === ',') {
        hoursForReturn = hours.slice(1, hours.length);
      }
      return `${minutesForReturn} ${hoursForReturn}`;
    },
    sortWeekdays(weekdays) {
      const sorter = {
        mon: 1,
        tue: 2,
        wed: 3,
        thu: 4,
        fri: 5,
        sat: 6,
        sun: 7,
      };
      weekdays.sort((a, b) => {
        const day1 = a.toLowerCase();
        const day2 = b.toLowerCase();
        return sorter[day1] - sorter[day2];
      });
      return weekdays;
    },
    noLettersOrSymbols: (value) => {
      if (!value) {
        return true;
      } else if (value.match(/[a-zA-Z!@#$%^&()_+\-=[\]{};':"\\|.<>/?]+/g)) {
        return 'Time input cannot contain letters or symbols';
      }
      return true;
    },
    noDuplicates: (value) => {
      if (!value) {
        return true;
      }
      const array = value.split(',');
      const set = new Set(array);
      if (set.size !== array.length) {
        return 'No duplicate values allowed';
      }
      return true;
    },
  },
  checkMinuteHourValues(minutes, hours) {
    let count = 0;
    minutes.split(',').forEach((min) => {
      if (min >= 60 || min < 0) {
        count += 1;
      }
    });
    hours.split(',').forEach((hour) => {
      if (hour >= 24 || hour < 0) {
        count += 1;
      }
    });
    return count >= 1;
  },
  prepareScheduleValuesForEdit(minutehour, weekValues) {
    const testForLetters = /[a-zA-Z]/g;
    let arrayOfTimes = [];
    let weekdays = weekValues;
    if (!testForLetters.test(minutehour)) {
      arrayOfTimes = minutehour.replaceAll(' ', '').split(',');
    } else {
      const arr = minutehour.split(': ');
      weekdays = arr[0].replaceAll(' ', '').split(',');
      const minutesAndHours = arr[1].split(',');
      let times = '';
      minutesAndHours.forEach((time) => {
        const splitMinutesAndHours = time.replaceAll(' ', '').split(':');
        times += `${splitMinutesAndHours[0]}:${splitMinutesAndHours[1]},`;
      });
      arrayOfTimes = times.slice(0, -1).replaceAll(' ', '').split(',');
    }
    const arrayOfMinutes = [];
    const arrayOfHours = [];
    arrayOfTimes.forEach((time) => {
      const tempArr = time.split(':');
      arrayOfHours.push(tempArr[0]);
      arrayOfMinutes.push(tempArr[1]);
    });
    const uniqueHours = uniq(arrayOfHours);
    const uniqueMinutes = uniq(arrayOfMinutes);
    return [uniqueHours.join(','), uniqueMinutes.join(','), weekdays];
  },
};



// WEBPACK FOOTER //
// ./src/components/schedules/format.js